import React, { useEffect, useRef, useState } from "react";
import Classes from "./styles/style.module.css";
import { useLocation, useNavigate } from "react-router";
import useHomeAddress from "../../assets/Hooks/getHomeAddress";
import api from "../../assets/utils/Api";
import errorHandler from "../../assets/utils/ErrorHandler";
import Loading from "../../assets/containers/loadingDialog";

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

const AccessCheck = () => {
  const [personalCode, setPersonalCode] = useState("");
  const [loadingRequest, setLoadingRequest] = useState(false);

  const navigate = useNavigate();
  const { homeAddress } = useHomeAddress();
  const inputRef = useRef();

  let query = useQuery();
  let redirect = query.get("redirect");
  let topic = query.get("topic");
  let type = query.get("type");
  let identifier= query.get("identifier");
  let identifierTitle= query.get("identifierTitle");

  useEffect(() => {
    document.body.classList.add("profileBg");
    if (inputRef) {
      inputRef.current.focus();
    }
    return () => {
      document.body.classList.remove("profileBg");
    };
  }, []);

  const backToHome = () => {
    navigate(homeAddress);
  };

  const handleChangePersonalCodeInput = (e) => {
    setPersonalCode(e.target.value);
  };

  const handleSubmitPersonalCode = async () => {
    if (personalCode !== "") {
      setLoadingRequest(true);
      try {
        await api
          .post("/accessv2/check", {
            identifier: personalCode,
            topic: topic ? topic : "General",
            type: type
          })
          .then(({ data }) => {
            setPersonalCode("");
            if (data) {
              setLoadingRequest(true);
              window.location.replace(
                `${redirect}&identifier=${data.data.identifier}`
              );
            }
          });
      } catch (error) {
        setLoadingRequest(false);
        errorHandler(error);
      }
    }
  };

  return (
    <div className={Classes.PersonalCodeDialog}>
      <div className={Classes.personalCodeDialogConatiner}>
        <div className="row col-12 mx-0 px-0">
          <p className="col-12 text-center">لطفا {identifierTitle} خود را وارد کنید:</p>
          <input
            placeholder={identifierTitle}
            className={Classes.personalCodeInput}
            ref={inputRef}
            value={personalCode}
            onChange={handleChangePersonalCodeInput}
          />
          {loadingRequest ? (
            <div className="row col-12 justify-content-center mx-0 mt-4 mb-2">
              <Loading size={30} />
            </div>
          ) : (
            <div className="row col-12 justify-content-between mx-0 mt-4 mb-2">
              <button
                className={Classes.DialogButton}
                onClick={handleSubmitPersonalCode}
              >
                تایید
              </button>
              <button className={Classes.DialogButton} onClick={backToHome}>
                بازگشت
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default AccessCheck;
